import { computed, MaybeRefOrGetter, toValue, CSSProperties } from 'vue';

interface UseDriverStatsStylesOptions {
	columnWidth?: number;
	extraColumns?: MaybeRefOrGetter<number>;
}

export function useDriverStatsStyles(selectedStats: MaybeRefOrGetter<any[] | undefined>, options: UseDriverStatsStylesOptions = {}) {
	const columnWidth = options.columnWidth ?? 80;

	const dynamicStatsStyle = computed((): CSSProperties => {
		const selectedCount = toValue(selectedStats)?.length || 0;
		const extraColumns = toValue(options.extraColumns) ?? 1;
		const totalWidth = (selectedCount + extraColumns) * columnWidth;

		return {
			width: `${totalWidth}px`,
			minWidth: `${totalWidth}px`,
			maxWidth: `${totalWidth}px`,
			flex: `0 0 ${totalWidth}px`,
		};
	});

	return {
		dynamicStatsStyle,
	};
}
